import * as React from 'react';
import { useFormikContext } from 'formik';
import { Button } from '../../buildingBlocks/Button';
export const SubmitButton = ({ disabled = false, label = 'Submit', className = '', form }) => {
    const { isSubmitting } = useFormikContext();
    return (React.createElement(Button, { type: "submit", disabled: disabled || isSubmitting, className: className, form: form }, label));
};
